import { JSONToHTMLTable } from '@kevincobain2000/json-to-html-table'
import * as React from 'react'
import { Show, SimpleShowLayout, TextField, DateField, FunctionField } from 'react-admin'
import { ProviderField } from '../fields/kitFields'
import { Title } from './helpers/NotificationDetailsHelpers'

export default function NotificationDetails() {
  return (
    <Show title={<Title />}>
      <SimpleShowLayout spacing={2} className="details-page-layout">
        <FunctionField
          label="Reference"
          render={(record) => {
            if (record.kitId) {
              return <a href={`#/kits/${record.kitId}/show`}>{record.kitId}</a>
            }
            if (record.requestId) {
              return <a href={`#/kit-requests/${record.requestId}/show`}>{record.requestId}</a>
            }
            return null
          }}
        />
        <TextField source="eventType" label="Event Type" />
        <FunctionField
          label="Created"
          render={(record) => {
            if (!record.createdAt) return null
            const d = new Date(record.createdAt)
            const date = `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}/${d.getFullYear()}`
            const time = `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`
            return `${date} ${time}`
          }}
        />
        <DateField source="requestedAt" label="Requested" />
        <TextField source="type" label="Type" />
        <TextField source="method" label="Method" />
        <TextField source="status" label="Status" />
        <ProviderField label="Provider Info" />
        <TextField source="faxNumber" label="Fax Number" />
        <TextField source="patientName" label="Patient Name" />
        <TextField source="emailAddress" label="Email Contacted" />
        <TextField source="textNumber" label="Phone Contacted" />
        <TextField source="notes" label="Notes" />
        <TextField source="serviceProviderType" label="Service Provider Type" />
        <TextField source="serviceProviderId" label="Service Provider Id" />
        <TextField source="serviceProviderStatus" label="Service Provider Status" />
        <FunctionField
          source="serviceProviderData"
          label="Service Provider Data"
          render={(record) => {
            return <JSONToHTMLTable data={record.serviceProviderData ?? {}} tableClassName="detail_table " />
          }}
        />
      </SimpleShowLayout>
    </Show>
  )
}
